export default {
  notes: 'Notes',
  allNotes: 'All Notes',
  edit: 'Edit',
  delete: 'Delete',
  saveNote: 'Save Note',
};
